module.exports = __webpack_public_path__ + "img/posting_photo.91f68c2e.svg";